import React from 'react';
import { Flex, Text, Box } from '@chakra-ui/react';

export const GameInfoPromo = () => {
    return (
        <Flex flexDirection='column' w='40%' pl='32px'>
            <Flex flexDirection='column' gap='-12px' pb='8px'>
                <Text fontSize='8px' fontWeight='700'>2Dynamic Games</Text>
                <Text fontSize='26px' fontWeight='700'>Lumencraft</Text>
            </Flex>
            <Text fontSize='9px' color='#E5E5E5' fontWeight='400' pb='12px'>Desperate, outnumbered and with gun turrets as your only companion. Lumencraft is a top-down shooter with base-building elements.</Text>
            <Flex pb='4px'>
                <Box display='flex' bgColor='#BEA379' fontSize='8px' fontWeight='600' borderRadius='2px' p='1px 6px'>
                    GOLD
                </Box>
            </Flex>
            <Flex gridGap='12px' pt='12px' align='center'>
            <Box display='flex' height='26px' width='86px' bgColor='#FF3F3F' borderRadius='4px' alignItems='center' justifyContent='center' fontSize='10px' fontWeight='700' p='0px 12px'>
                Read more
            </Box>
                <Text fontSize='20px' fontWeight='700'>$12</Text>
            </Flex>
        </Flex>
    );
};

export default GameInfoPromo;
